import React from "react";

const MessageContext = React.createContext({
  displaySuccess: () => {},
  displayWarning: () => {},
  displayError: () => {},
});

export default MessageContext;
